"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAvatar = addAvatar;
exports.batchDeleteAvatar = batchDeleteAvatar;
exports.deleteAvatar = deleteAvatar;
exports.getAvatarInfo = getAvatarInfo;
exports.getAvatarList = getAvatarList;
exports.updateAvatar = updateAvatar;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 分页查询社区-形象管理
function getAvatarList(query) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityFigure/page',
    method: 'get',
    params: query
  });
}

// 获取形象详情
function getAvatarInfo(id) {
  return (0, _requestAuth.default)({
    url: "/xyCommunityFigure/".concat(id),
    method: 'get'
  });
}

// 新增形象
function addAvatar(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityFigure',
    method: 'post',
    data: data
  });
}

// 修改形象
function updateAvatar(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityFigure',
    method: 'put',
    data: data
  });
}

// 删除形象
function deleteAvatar(id) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityFigure',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 批量删除形象
function batchDeleteAvatar(ids) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityFigure/batchDelete',
    method: 'post',
    data: ids
  });
}